import $store from '@/modules/FPKG-50000-Vuex/index'; // lists 與axios溝通
import Header from '@/modules/FPKG-10000-Theme/layout/DEFAULT/Header.vue';

const socket = (data: string) => {
  localStorage.setItem('idle_time', data);
  // 紀錄當前時間
  const now = new Date().getTime();
  const timestamp = Math.floor(now / 1000);
  localStorage.setItem('timestamp', String(timestamp));
};
export default { socket };
